import { render } from "./MenuDataTools.vue?vue&type=template&id=3bbc1e5a&ts=true"
import script from "./MenuDataTools.vue?vue&type=script&lang=ts"
export * from "./MenuDataTools.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__